import React, { createContext } from "react";
import config from "../config";

// Create a context
export const EnvContext = createContext();
export const environment = process.env.REACT_APP_ENV || "production";
export const collectionPath = environment === "staging"
  ? config.environment.staging.collectionPath
  : config.environment.production.collectionPath;

const EnvProvider = ({ children }) => {
  return <EnvContext.Provider value={environment}>{children}</EnvContext.Provider>;
};

export default EnvProvider;
